<template>
  <b-container>
    <b-row class="mt-3">
      <b-col>
        <div>U hebt geen toegang tot deze functie.<br>Kies een van de opties uit het menu om verder te gaan.</div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'Forbidden',
    data() {
      return {        
      }
    }
  }
</script>
